import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement, // Register point elements for the line chart
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// my component for sorting Labels
import { SortChartLabels } from "./SortChartLabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement, // Add the missing element here
  Title,
  Tooltip,
  Legend
);

const ChartsPageLineTypeAQI = (props) => {
  const { labels, data, parameter, dataType, rangeType } = props;
  const [titleText, setTitleText] = useState("داده‌ها"); // Correct state initialization

  const setTheColorOfAqi = (x) => {
    if (x <= 50) {
      return "#0f9d63";
    } else if (x > 50 && x <= 100) {
      return "#ffd700";
    } else if (x > 100 && x <= 150) {
      return "#ff8c00";
    } else if (x > 150 && x <= 200) {
      return "#ff0000";
    } else if (x > 200 && x <= 300) {
      return "#800080";
    } else if (x > 300) {
      return "#a52a2a";
    } else {
      return "#8f8f8f";
    }
  };

  // Reverse labels and data arrays
  const sortedChartLabels = SortChartLabels(labels, dataType, rangeType);
  const reversedData = [...data].reverse();

  // Generate chart colors based on reversed data
  const chartColors = reversedData.map((item) => setTheColorOfAqi(item));

  // Chart data configuration using reversedData and chartColors
  const chartData = {
    labels: sortedChartLabels.persianLabels,
    datasets: [
      {
        data: reversedData,
        backgroundColor: chartColors,
        borderColor: chartColors,
        borderWidth: 0,
        fill: true,
        label: "AQI Data",
      },
    ],
  };

  const changeTitleText = () => {
    switch (parameter) {
      case "aqi":
        setTitleText("شاخص کیفیت هوا");
        break;
      case "pm25":
        setTitleText("شاخص ذرات معلق PM 2.5");
        break;
      case "pm10":
        setTitleText("شاخص ذرات معلق PM 10");
        break;
      case "co":
        setTitleText("شاخص گاز منواکسید کربن");
        break;
      case "o3":
        setTitleText("شاخص گاز ازن");
        break;
      case "so2":
        setTitleText("شاخص گاز گوگرد دی اکسید");
        break;
      case "no2":
        setTitleText("شاخص گاز نیتروژن دی اکسید");
        break;
      case "temperature":
        setTitleText("دما");
        break;
      case "humidity":
        setTitleText("رطوبت");
        break;
      case "pressure":
        setTitleText("فشار");
        break;
      case "spl":
        setTitleText("صدا");
        break;
      case "voc":
        setTitleText("بوی ناشی از تجزیه ترکیبات آلی");
        break;
      default:
        setTitleText("داده‌ها");
    }
  };

  useEffect(() => {
    changeTitleText();
  }, [parameter]);

  return (
    <div>
      <Line
        className="chart-secondary mx-auto my-5 mw-100"
        style={{ width: "90%" }}
        data={chartData}
        options={{
          maxBarThickness: 45,
          responsive: true,
          scales: {
            x: {
              stacked: true, // Do not stack horizontally
            },
            y: {
              stacked: true, // Stack vertically
            },
          },
          plugins: {
            title: {
              display: true,
              text: titleText,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
              callbacks: {
                title: (tooltipItems) => {
                  return tooltipItems[0].label;
                },
                label: (tooltipItem) => {
                  const dataIndex = tooltipItem.dataIndex;

                  // Calculate the sum of all datasets for this bar
                  const sum = tooltipItem.chart.data.datasets.reduce(
                    (acc, dataset) => acc + dataset.data[dataIndex],
                    0
                  );

                  return `AQI: ${sum}`;
                },
              },
              boxPadding: 0, // This reduces padding inside the tooltip
              boxWidth: 0, // Hides the color box
              boxHeight: 0, // Hides the color box
            },
            datalabels: {
              display: false, // Ensure data labels are hidden if datalabels plugin is used
            },
          },
        }}
      />
    </div>
  );
};

export default ChartsPageLineTypeAQI;
